import VueRouter from 'vue-router';
// Advisor -2.X.Y Web Platform:

// All Routes
import RootRoutes from '@advisor/routes/index';
import AdvisorProfile from '@advisor/routes/advisorprofile';
import Summary from '@advisor/routes/summary';
import Clients from '@advisor/routes/clients';
import Households from '@advisor/routes/households';
import InvestmentModels from '@advisor/routes/investmentmodels';
import InvestmentSetup from '@advisor/routes/investmentSetup';
import ManageAccess from '@advisor/routes/manageaccess';
import PrivateLabel from '@advisor/routes/privatelabel';
import ManageFirm from '@advisor/routes/managefirm';
import ManageDocuments from '@advisor/routes/managedocuments';
import SegmentSettings from '@advisor/routes/segmentsettings';
import InitiateAccountTransfer from '@advisor/routes/InitiateAccountTransfer';
import ClientAuthentication from '@advisor/routes/clientAuthentication';
import OpenClientAccount from '@advisor/routes/openClientAccount';
import SupervisorApproval from '@advisor/routes/supervisorApproval';

import {beforeEach} from '@advisor/util/router/beforeEach';
import {afterEach} from '@advisor/util/router/afterEach';

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location, onResolve, onReject) {
  try {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);

    return originalPush.call(this, location).catch((error) => {
      throw error;
    });
  } catch (error) {
    throw new Error(`[VueRouter] - ${error}`);
  }
};

const routes = [
  ...RootRoutes,
  ...AdvisorProfile,
  ...Clients,
  ...Households,
  ...InvestmentModels,
  ...InvestmentSetup,
  ...ManageAccess,
  ...ManageDocuments,
  ...ManageFirm,
  ...PrivateLabel,
  ...SegmentSettings,
  ...Summary,
  ...InitiateAccountTransfer,
  ...ClientAuthentication,
  ...OpenClientAccount,
  ...SupervisorApproval,
];

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'active',
  linkExactActiveClass: 'active',
  routes: routes.flat(),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    return {x: 0, y: 0};
  },
});

beforeEach.forEach((fn) => router.beforeEach(fn));
afterEach.forEach((fn) => router.afterEach(fn));

export default router;
